import React, { useState, useEffect, lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { supabase, AuthScreen } from './App';
import App from './App';

const LandingPage = lazy(() => import('./LandingPage'));

function LoadingScreen() {
  return (
    <div style={{display:'flex', alignItems:'center', justifyContent:'center', minHeight:'100vh', background:'#FDF6EE', fontFamily:'Outfit,sans-serif', color:'#7A6F67'}}>
      Loading...
    </div>
  );
}

function SignupRoute({ user, guestMode, setUser, setGuestMode }) {
  const navigate = useNavigate();
  if (user) return <Navigate to="/app" replace />;
  if (guestMode) return <Navigate to="/app" replace />;
  return (
    <AuthScreen onAuth={(u) => {
      if (u === null) {
        ['morningItems','eveningItems','clearedGrocery','clearedAiSort','clearedProfile','clearedSitch','clearedLeaveTime','clearedGuestHabits'].forEach(k=>localStorage.removeItem(k));
        localStorage.setItem('clearedGuestMode','true');
        setGuestMode(true);
        navigate('/app');
      } else {
        setUser(u);
        navigate('/app');
      }
    }} />
  );
}

function ProtectedRoute({ user, guestMode, loading, children }) {
  if (loading) return <LoadingScreen />;
  if (!user && !guestMode) return <Navigate to="/signup" replace />;
  return children;
}

export default function AppRouter() {
  const [user, setUser] = useState(null);
  const [guestMode, setGuestMode] = useState(() => localStorage.getItem('clearedGuestMode') === 'true');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
      setLoading(false);
    });
    return () => subscription.unsubscribe();
  }, []);

  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/signup" element={
            <SignupRoute user={user} guestMode={guestMode} setUser={setUser} setGuestMode={setGuestMode} />
          } />
          <Route path="/app" element={
            <ProtectedRoute user={user} guestMode={guestMode} loading={loading}>
              <App user={user} setUser={setUser} guestMode={guestMode} setGuestMode={setGuestMode} />
            </ProtectedRoute>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
